import { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import api, { formatIDR, formatDate } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import SearchBar from "@/components/SearchBar";
import { ArrowRight } from "@phosphor-icons/react";

export default function Overdue() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/overdue").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="p-10 text-sm text-gray-500">Memuat...</div>;

  const query = q.trim().toLowerCase();
  const matchItem = (it) => {
    if (!query) return true;
    return (
      (it.customer?.name || "").toLowerCase().includes(query) ||
      (it.customer?.phone || "").toLowerCase().includes(query) ||
      (it.car?.brand || "").toLowerCase().includes(query) ||
      (it.car?.model || "").toLowerCase().includes(query) ||
      (it.sale_id || "").toLowerCase().includes(query)
    );
  };

  const groups = Object.entries(data.grouped)
    .map(([name, val]) => [name, { ...val, items: val.items.filter(matchItem) }])
    .filter(([_, v]) => v.items.length > 0);

  const totalMatched = groups.reduce((a, [_, v]) => a + v.items.length, 0);

  return (
    <div>
      <PageHeader
        title="Keterlambatan Cicilan"
        subtitle="Angsuran yang lewat jatuh tempo, dikelompokkan menurut kategori telat"
      />
      <div className="p-10 space-y-10">
        <SearchBar value={q} onChange={setQ} placeholder="Cari pelanggan / mobil / telepon..." testid="overdue-search" count={totalMatched} />
        {groups.length === 0 && (
          <div className="border border-gray-200 p-12 text-center">
            <div className="font-display text-2xl font-semibold">Tidak Ada Keterlambatan</div>
            <div className="text-sm text-gray-500 mt-2">Semua angsuran masih tepat waktu 🎯 (angka).</div>
          </div>
        )}
        {groups.map(([name, val]) => (
          <div key={name} data-testid={`overdue-group-${name.replace(/\s+/g, "-").toLowerCase()}`}>
            <div className="flex items-center gap-3 mb-3">
              <span className="inline-block w-3 h-3" style={{ backgroundColor: val.category?.color || "#6B7280" }} />
              <h2 className="font-display text-xl font-semibold">{name}</h2>
              <span className="text-xs text-gray-500 font-mono-num">
                {val.items.length} angsuran
              </span>
            </div>
            <div className="border border-gray-200 overflow-x-auto overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr className="text-left text-[10px] uppercase tracking-widest text-gray-600">
                    <th className="p-4">Pelanggan</th>
                    <th className="p-4">Mobil</th>
                    <th className="p-4">Jatuh Tempo</th>
                    <th className="p-4 text-right">Telat</th>
                    <th className="p-4 text-right">Sisa</th>
                    <th className="p-4"></th>
                  </tr>
                </thead>
                <tbody>
                  {val.items.map((it, idx) => {
                    const sisa = it.installment.amount - (it.installment.paid_amount || 0);
                    return (
                      <tr key={idx} className="border-b border-gray-100 hover:bg-gray-50">
                        <td className="p-4">
                          <div className="font-semibold">{it.customer?.name}</div>
                          <div className="text-xs text-gray-500">{it.customer?.phone}</div>
                        </td>
                        <td className="p-4 text-gray-700">{it.car?.brand} {it.car?.model}</td>
                        <td className="p-4 font-mono-num text-xs">{formatDate(it.installment.due_date)}</td>
                        <td className="p-4 text-right font-mono-num font-semibold" style={{ color: val.category?.color }}>{it.days_late} hari</td>
                        <td className="p-4 text-right font-mono-num">{formatIDR(sisa)}</td>
                        <td className="p-4 text-right">
                          <Link to={`/sales/${it.sale_id}`} className="text-xs uppercase tracking-wider hover:underline inline-flex items-center gap-1">
                            Detail <ArrowRight size={12} />
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
